/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Api_Error_InternalInputs */

const cs_api_error_internal = /** @type {(inputs: Api_Error_InternalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Došlo k chybě serveru. Zkuste to znovu nebo kontaktujte podporu.`)
};

const en_api_error_internal = /** @type {(inputs: Api_Error_InternalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A server error occurred. Try again or contact support.`)
};

/**
* | output |
* | --- |
* | "A server error occurred. Try again or contact support." |
*
* @param {Api_Error_InternalInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const api_error_internal = /** @type {((inputs?: Api_Error_InternalInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Api_Error_InternalInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_api_error_internal(inputs)
	return cs_api_error_internal(inputs)
});